<template>
  <b-modal
    id="add-or-update-modal"
    :visible="isAddActive"
    centered
    hide-footer
    hide-header
    no-close-on-esc
    no-close-on-backdrop
    size="md"
    @hidden="resetForm"
    @hide="resetForm"
    @change="(val) => $emit('update:is-add-active', val)"
  >
    <template #default="{ hide }">
      <b-overlay :show="loading" class="px-2">
        <div class="d-flex justify-content-between align-items-center content-sidebar-header py-1" style="border-bottom: 1px solid #000000;">
          <h5 class="mb-0" style="font-weight: 400; font-size: 14px; line-height: 160%;">
            Send Prescription
          </h5>

          <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
        </div>

        <validation-observer
          #default="{ handleSubmit }"
          ref="update_modal_form"
        >
          <b-form class="my-1" @submit.prevent="handleSubmit(onUpdate)" @reset.prevent="resetForm">
            <b-alert v-if="errorMessage" variant="danger" :show="true">
              <div class="alert-body font-small-2">
                <b-card-text class="mb-0">
                  {{ errorMessage }}
                </b-card-text>
              </div>
            </b-alert>
        
            <b-row>
              <b-col cols="12" md="12">
                <validation-provider #default="validationContext" name="Pharmacy" rules="required">
                  <b-form-group>
                    <template #label>
                      <span>Select Pharmacy<span style="color: tomato"> *</span></span>
                    </template>
                    
                    <pharmacy-select 
                      :value="pharmacy"
                      @change="val => pharmacy = val"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="12">
                <validation-provider #default="validationContext" name="Region" rules="required">
                  <b-form-group label-for="region">
                    <template #label>
                      <span>Region</span>
                    </template>
    
                    <b-form-select
                      id="region"
                      v-model="region"
                      placeholder="Region"
                      :options="regionOptions"
                      :state="getValidationState(validationContext)"
                    />
    
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="12">
                <validation-provider #default="validationContext" name="Location" rules="required">
                  <b-form-group label-for="location">
                    <template #label>
                      <span>Location</span>
                    </template>
    
                    <b-form-input
                      id="location"
                      v-model="location"
                      placeholder="Location"
                      :state="getValidationState(validationContext)"
                    />
    
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="12">
                <validation-provider #default="validationContext" name="Note" rules="">
                  <b-form-group label-for="note">
                    <template #label>
                      <span>Note</span>
                    </template>

                    <b-form-textarea
                      id="note"
                      v-model="doctor_note"
                      placeholder="Leave a note"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="12">
                <b-form-group label-for="prescriptions">
                  <template #label>
                    <span>Prescriptions</span>
                  </template>

                  <div v-if="prescriptionOptions.length">
                    <b-form-checkbox
                
                      v-for="option in prescriptionOptions"
                      :key="option.value"
                      v-model="selected"
                      :value="option.value"
                      class="mt-1 prescriptions"
                    >
                      {{ option.text }}
                    </b-form-checkbox>
                  </div>

                  <span v-else>No selected prescriptions to send.</span>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Form Actions -->
            <div class="d-flex mt-2">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-primary"
                class="mr-2"
                type="submit"
                :disabled="disableBtn"
                @click="onUpdate"
              >
                Send for delivery
              </b-button>

              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-danger"
                @click="hide"
              >
                Cancel
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-overlay>
    </template>
  </b-modal>
</template>
    
<script>
import {
  BOverlay, BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, 
  BFormTextarea, BFormInvalidFeedback, BButton, BFormSelect,
  BAlert, BCardText, BModal, BRow, BCol, BFormDatepicker
} from 'bootstrap-vue'

import { required } from '@validations'
import { get, cloneDeep } from 'lodash';
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'

import PharmacySelect from "@core/components/shared/admin/selects/PharmacySelect.vue"
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
  
const rawData = {}
    
export default {
  components: {
    BRow,
    BCol,
    BForm,
    BAlert,
    BModal,
    BButton,
    vSelect,
    BOverlay,
    BFormCheckbox,
    BSidebar,
    BCardText,
    BFormInput,
    BFormGroup,
    BFormSelect,
    BFormTextarea,
    BFormDatepicker,
    BFormInvalidFeedback,

    PharmacySelect,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddActive',
    event: 'update:is-add-active',
  },
  props: {
    resource: {
      type: String,
      required: true
    },
    isAddActive: {
      type: Boolean,
      required: true,
    },
    prescriptionData: {
      type: [Array, null],
      required: false,
      default: () => null
    },
    consultationData: {
      type: Object,
      required: true,
    },
    patientData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      loading: false,
      errorMessage: "",
      
      pharmacy: null,
      doctor_note: '',
      selected: [], 
      regionOptions: [],

      region: this.patientData.region,
      location: this.patientData.location,

      prescriptionOptions: null,
      form_data: cloneDeep(rawData),
    }
  },
  computed: {
    disableBtn(){
      return !this.pharmacy || !this.can(`${this.resource}:CanAddNew`)
    },
  },
  watch: {
    prescriptionData: {
      handler(v){
        if (v){
          this.form_data = v

          this.prescriptionOptions = v.map(item => {
            return {
              text: item.drug.generic_name,
              value: item.id
            };
          })
          this.selected = this.prescriptionOptions.map(option => option.value);
        } else {
          this.form_data = cloneDeep(rawData)
        }
      }, 
      immediate: true,
      deep: true
    }
  },
  created(){
    this.fetchGeoData();
  },
  methods: {
    async onUpdate(){
      try {
        this.loading = true;
        this.errorMessage = "";

        if (!this.can(`${this.resource}:CanAddNew`)) {
          return
        }

        const payload = {
          doctor_note: this.doctor_note,
          pharmacy_id: this.pharmacy,
          consultation_id: this.consultationData._id,
          region: this.region,
          location: this.location,
          prescriptions: this.prescriptionData.filter(opt => this.selected.includes(opt._id)).map(opt => opt._id)
        };

        await this.useJwt().mainService.prescriptionDeliveries.create(payload);

        this.$emit('refetchData');
        this.$emit('update:is-add-active', false);

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Success!',
            variant: 'success',
            icon: 'CheckCircleIcon',
            text: `Prescription sent successfully`
          },
        });
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
    async fetchGeoData(){
      try {
        this.loading = true;
        this.errorMessage = "";

        const query = {
          geo_id: 2300660
        }
        
        const response = await this.useJwt().mainService.geoData.list(query);
        const data = get(response, 'data.data');

        this.regionOptions = data.map((reg) => ({
          value: reg.name,
          text: reg.name,
        }))
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        this.errorMessage = error_message;

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false
      }
    },
    resetForm() {
      this.form_data = cloneDeep(rawData);
      if (this.$refs.update_modal_form) {
        this.$refs.update_modal_form.reset()
      }
    },
  }
}
</script>
  
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.hide-btn {
  color: red !important;
  background-color: transparent !important;
}
</style>
